import { Card } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScanOutlined } from '@ant-design/icons';

export const CoverageDetailSection: React.FC = () => {
  const { t } = useTranslation();

  const paymentMethodsByCountry = [
    {
      flag: '/images/flags/argentina.svg',
      name: 'Argentina',
      paymentMethods: [
        { icon: '/images/icons/banktransfer.svg', name: 'banktransfer' },
        { icon: '/images/icons/qr.svg', name: 'qr' },
      ],
    },
    {
      flag: '/images/flags/brazil.svg',
      name: 'Brazil',
      paymentMethods: [{ icon: '/images/icons/pix.svg', name: 'pix' }],
    },
    {
      flag: '/images/flags/colombia.svg',
      name: 'Colombia',
      paymentMethods: [
        { icon: '/images/icons/pse.png', name: 'pse' },
        { icon: '/images/icons/banktransfer.svg', name: 'banktransfer' },
      ],
    },
    {
      flag: '/images/flags/mexico.svg',
      name: 'Mexico',
      paymentMethods: [
        { icon: '/images/icons/codi.png', name: 'codi' },
        { icon: '/images/icons/spei.png', name: 'spei' },
      ],
    },
  ];

  return (
    <section
      className="bg-no-hidden-fees bg-no-repeat bg-cover py-16 px-4 md:px-10 lg:px-20
      w-full max-w-[1204px] overflow-hidden
      lg:w-[1204px]"
    >
      <div className="text-center mb-12 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 pb-10">
          {t('coverageDetail.title')}
        </h2>
        <p className="text-gray-600 mt-4 pb-10">
          {t('coverageDetail.subTitle')}
        </p>
      </div>

      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {paymentMethodsByCountry.map((country) => (
          <Card
            key={country.name}
            title={
              <div className="flex items-center gap-2 text-lg font-semibold text-gray-800">
                <img
                  src={country.flag}
                  alt={country.name}
                  className="w-6 sm:w-8 rounded-full object-cover"
                />
                {country.name}
              </div>
            }
            className="rounded-2xl shadow-sm hover:shadow-md transition-all"
          >
            <ul className="space-y-2">
              {country.paymentMethods.map((method) => (
                <li>
                  <div className="flex items-center gap-2 text-[14px] font-semibold text-gray-800">
                    {method.name === 'qr' ? (
                      <div className="w-9 h-9 bg-[#f1f5fe] rounded-xl flex items-center justify-center shrink-0">
                        <ScanOutlined
                          style={{ color: '#005fcc', fontSize: 22 }}
                        />
                      </div>
                    ) : (
                      <img
                        src={method.icon}
                        alt={method.name}
                        className="w-4 sm:w-8 rounded-full object-cover"
                      />
                    )}
                    {method.name}
                  </div>
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>
    </section>
  );
};
